import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IShowMoreBtnProps {
  text: string;
  onClick(): void;
  onView(): void;
}

export const OpenFullscreenBtn: React.FC<React.PropsWithChildren<IShowMoreBtnProps>> = ({ onClick, text, onView }) => {
  return (
    <ActionAfterViewObserver callback={onView} callbackDelay={1500} wrapper={false}>
      <div className={styles['show-more']} data-testid="offers_history_fullscreen_open">
        <button type="button" className={styles['show-more-btn']} onClick={() => onClick()}>
          <UIText1 color="text-main-default" display="inline">
            {text}
          </UIText1>
        </button>
      </div>
    </ActionAfterViewObserver>
  );
};
